import { render } from "./BoundingBoxSizeFilter.vue?vue&type=template&id=738d2538&scoped=true"
import script from "./BoundingBoxSizeFilter.vue?vue&type=script&lang=js"
export * from "./BoundingBoxSizeFilter.vue?vue&type=script&lang=js"

import "./BoundingBoxSizeFilter.vue?vue&type=style&index=0&id=738d2538&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738d2538"]])

export default __exports__